'use client';

import { PageLoader } from 'components/PageLoader';

export default function Loading() {
  return <PageLoader />;
}
